<template>
  <div :style="{direction:$t('direction')}">
    <div class="dashboard">
      <Sidebar />
      <div class="content">
        <Header />
        <div class="dashboard-content">
          <HelperNav />
          <div class="dashboard-wrapper">

            
            <div class="ar-card">
              <div class="ar-card-header">
                <div class="ar-card-title">
                  امنیت 
                </div>
                <div>
                </div>
              </div>
              <div class="ar-card-body">
                
                <accordion size="sm" class="mb-3">
                  <template v-slot:title>
                    فعال سازی ایمیل
                  </template>
                  <template v-slot:content>
                    بزودی
                  </template>
                </accordion>
                
                <accordion size="sm" class="mb-3">
                  <template v-slot:title>
                    احراز دو مرحله ای
                  </template>
                  <template v-slot:content>
                    بزودی
                  </template>
                </accordion>
                
                <accordion size="sm" class="mb-3">
                  <template v-slot:title>
                     پیامک
                  </template>
                  <template v-slot:content>
                    بزودی
                  </template>
                </accordion>
                
                <accordion size="sm">
                  <template v-slot:title>
                    تغییر رمز عبور
                  </template>
                  <template v-slot:content>

                  <div class="container">
                    <div class="row">
                                      
                      <div class="ar-form-group">
                        <div class="ar-form-append">
                          <input class="ar-form-control text-center" v-model="form.current_password" :type="[show_password ? 'text' : 'password']" placeholder="رمز عبور فعلی" />
                          <span class="ar-form-icon" @click="show_password = !show_password">
                            <i v-if="show_password" class="fa fa-eye"></i>
                            <i v-else class="fa fa-eye-slash"></i>
                          </span>
                        </div>
                        <div v-if="errors.current_password" class="ar-form-text">
                          <small>{{errors.current_password[0]}}</small>
                        </div>
                      </div>
                      <div class="ar-form-group">
                        <input class="ar-form-control text-center" v-model="form.new_password" :type="[show_password ? 'text' : 'password']" placeholder="رمز عبور جدید" />
                        <div v-if="errors.new_password" class="ar-form-text">
                          <small>{{errors.new_password[0]}}</small>
                        </div>
                      </div>
                      <div class="ar-form-group">
                        <input class="ar-form-control text-center" v-model="form.password_confirmation" :type="[show_password ? 'text' : 'password']" placeholder="تکرار رمز عبور" />
                        <div v-if="errors.password_confirmation" class="ar-form-text">
                          <small>{{errors.password_confirmation[0]}}</small>
                        </div>
                      </div>
        

                      <div class="col-12 my-3 text-center">
                        <button @click="changePassword" class="ar-btn size-md primary round">ثبت</button>
                      </div>

                        
                      <div class="p-3 mb-3" style="font-size:12px">
                        <div>رمز عبور شما باید شامل این موارد باشد:</div>
                        <div>
                          <span><i class="fa fa-check-square-o"></i></span>
                          حروف بزرگ و کوچک انگلیسی
                        </div>
                        <div>
                          <span><i class="fa fa-check-square-o"></i></span>
                          عدد
                        </div>
                        <div>
                          <span><i class="fa fa-check-square-o"></i></span>
                          علائم (@ , / , % و ...)
                        </div>
                      </div>
                    
                    </div>
                  </div>
                    
                  </template>
                </accordion>

              </div>
              

            </div>
            

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Sidebar from './partials/Sidebar'
import Header from './partials/Header'
import HelperNav from './partials/HelperNav'
import Accordion from '../../components/Accordion'
export default {
  name: 'Security',
  components:{
    Accordion,
    Sidebar,
    HelperNav,
    Header
  },
  data : () => ({
    form:{},
    errors:{},
    errorMessage:null,
    show_password:false,
    loading:false,
  }),
  methods:{
    changePassword(){
      this.errorMessage = null
      this.errors = {}
      this.activeLoading(true)
      const api_token = this.getToken()
      
      this.$axios.post(`ChangePassword`, this.form ,
      {
        headers: {
          'api_token':api_token
        }
      })
      .then( () => {
        this.activeLoading(false)
        this.$notify({
          group: 'foo',
          type: 'success',
          duration: 5000,
          text: 'رمز عبور با موفقیت بروزرسانی شد'
        });
        this.form = {};
      })
      .catch(err => {
        if(err.response.data.message){
          this.errorMessage = err.response.data.message
          this.errors = {}
          this.$notify({
            group: 'foo',
            type: 'error',
            duration: 5000,
            text: this.errorMessage
          });
        }else if(err.response.data.errors){
          this.errors = err.response.data.errors
          this.errorMessage = null
        }
        this.activeLoading(false)
      });

    },
  },
  mounted() {
    this.activeLoading(false)
    this.checkAuth()
    this.checkConfirmed()
  }
}
</script>
<style scoped>
.custom{
  font-size: 18px !important;
  padding: 12px 32px !important;
}

.input {
    font-size: 14px;
    text-align: center;
}

.input input {
    width: 100%;
    text-align: center;
    padding: 6px;
    border-radius: 12px;
    margin-bottom: 10px;
    outline: none;
    border: 1px solid var(--lines);
    color: var(--theme2);
}

</style>